function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Top-Navigation",
  transform: "translate(-31.000000, -13.000000)",
  fill: "#323E48"
}, /*#__PURE__*/React.createElement("g", {
  id: "nav-bar/Retailer"
}, /*#__PURE__*/React.createElement("g", {
  id: "JOOR-Logo---New-Viz",
  transform: "translate(31.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79.4969986,13.4747164 L80.9195552,13.4747164 C85.3865001,13.4747164 88.5065239,10.7913845 88.5065239,6.94919819 C88.5065239,3.29017286 85.1738777,0.423913043 80.9195552,0.423913043 L75.9831081,0.423913043 L75.9831081,1.98637418 L80.9195552,1.98637418 C84.2936488,1.98637418 86.9364429,4.16636285 86.9364429,6.94919819 C86.9364429,9.91775784 84.5184479,11.9124882 80.9195552,11.9124882 L76.0980835,11.9113231 L86.994516,25.0956522 L89.25,25.0956522 L79.4969986,13.4747164 Z",
  id: "Fill-187"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.74153581,18.3830727 C7.74153581,25.1395436 5.22421022,26.7482161 0.0105180735,27.6641621 L0,29.25 C6.03410188,28.1683868 9.30405405,26.1160712 9.30405405,18.3830727 L9.30405405,0.423913043 L7.74153581,0.423913043 L7.74153581,18.3830727 Z",
  id: "Fill-189"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.0507257,5.44126551 C36.7518198,7.37799899 37.7856986,9.90787166 37.7856986,12.675 C37.7856986,18.7483258 32.8153437,23.6894433 26.7060811,23.6894433 C20.5968184,23.6894433 15.6264635,18.7483258 15.6264635,12.675 C15.6264635,6.60167417 20.5968184,1.66055668 26.7060811,1.66055668 C29.4319108,1.66055668 31.9293963,2.6461699 33.8614134,4.27503034 L35.0488502,3.09457847 C32.8125305,1.16833272 29.8975079,0 26.7060811,0 C19.664452,0 13.9560811,5.67479222 13.9560811,12.675 C13.9560811,19.6752078 19.664452,25.35 26.7060811,25.35 C33.7477102,25.35 39.4560811,19.6752078 39.4560811,12.675 C39.4560811,9.44501333 38.2388705,6.49912752 36.2381625,4.26081364 L35.0507257,5.44126551 Z",
  id: "Fill-191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.8766391,19.9087345 C45.1755451,17.972001 44.1416662,15.4421283 44.1416662,12.675 C44.1416662,6.60167417 49.1120211,1.66055668 55.2212838,1.66055668 C61.3305464,1.66055668 66.3009013,6.60167417 66.3009013,12.675 C66.3009013,18.7483258 61.3305464,23.6894433 55.2212838,23.6894433 C52.4954541,23.6894433 49.9979685,22.7038301 48.0659514,21.0749697 L46.8785146,22.2554215 C49.1148344,24.1816673 52.0298569,25.35 55.2212838,25.35 C62.2629129,25.35 67.9712838,19.6752078 67.9712838,12.675 C67.9712838,5.67479222 62.2629129,0 55.2212838,0 C48.1796547,0 42.4712838,5.67479222 42.4712838,12.675 C42.4712838,15.9049867 43.6884944,18.8508725 45.6892023,21.0891864 L46.8766391,19.9087345 Z",
  id: "Fill-193"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-186",
  points: "74.1705441 24.8265136 74.1705441 0.423913043 72.6233108 0.423913043 72.6233108 25.0956522 74.1739865 25.0956522 74.1739865 24.8265136"
})))));

function SvgLogoJoorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "30px",
    viewBox: "0 0 90 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JOOR Logo - New Viz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJoorDark);
export default __webpack_public_path__ + "static/media/logo_joor_dark.8d4e3829.svg";
export { ForwardRef as ReactComponent };